import React from "react";
import AddPurchaseOrderForm from "../../../components/forms/inventory/addPurchaseOrderForm";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";

const AddPurchaseOrder = () => {
  const items = [
    { label: "Purchase Order", path: "/inventory/purchase-order" },
    { label: "Create", path: "" },
  ];

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />

      <div>
        <AddPurchaseOrderForm />
      </div>
    </div>
  );
};

export default AddPurchaseOrder;
